module.exports = __webpack_public_path__ + "img/Group-1944.d9ac0e5f.png";